import React from 'react';
import {
  SectionContainer,
  LeftContainer,
  RightContainer,
  SectionTitle,
  StepCard,
  StepContent,
  StepTitle,
  StepIcon,
  StepDescription,
  PersonImage
} from './styles';
import cartIcon from '../../../assets/images/cart-icon.svg';
import envelopeIcon from '../../../assets/images/envelope-icon.svg';
import deliveryIcon from '../../../assets/images/delivery-icon.svg';
import paymentIcon from '../../../assets/images/payment-icon.svg';
import personImg from '../../../assets/images/person-smiling.png';

const HowItWorksSection = () => {
  const steps = [
    {
      icon: cartIcon,
      title: "Selecciona tu Producto",
      description: "Elige el curso o contenido que deseas desde nuestro marketplace o el sitio del vendedor aliado. Sin registros complicados ni pagos adelantados."
    },
    {
      icon: envelopeIcon,
      title: "Preparación y Envío a tu Puerta",
      description: "Floqss prepara un sobre físico con tu acceso personalizado (usuario y contraseña) y lo envía directamente a tu casa."
    },
    {
      icon: deliveryIcon,
      title: "Entrega Segura y Confiable",
      description: "Recibe tu acceso con total seguridad, directamente en tus manos, sin compartir tarjetas ni datos bancarios. Entregado por las transportadoras más confiables del país."
    },
    {
      icon: paymentIcon,
      title: "Pagas Solo al Recibir",
      description: "Solo pagas cuando el sobre llega a tus manos. Acceso inmediato, sin riesgos, sin complicaciones."
    }
  ];

  return (
    <SectionContainer>
      <LeftContainer>
        <SectionTitle>Cómo funciona en la práctica:</SectionTitle>
        
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <StepCard>
              <StepContent>
                <StepTitle>{step.title}</StepTitle>
                <StepIcon>
                  <img src={step.icon} alt={`Ícono ${step.title}`} />
                </StepIcon>
              </StepContent>
            </StepCard>
            <StepDescription>{step.description}</StepDescription>
          </React.Fragment>
        ))}
      </LeftContainer>
      
      <RightContainer>
        <PersonImage src={personImg} alt="Persona sonriendo con celular" />
      </RightContainer>
    </SectionContainer>
  );
};

export default HowItWorksSection;